import { render } from "./ResourceLinks.vue?vue&type=template&id=f09599d8&scoped=true"
import script from "./ResourceLinks.vue?vue&type=script&lang=js"
export * from "./ResourceLinks.vue?vue&type=script&lang=js"

import "@/assets/styles/resourcelinks.css?vue&type=style&index=0&id=f09599d8&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f09599d8"]])

export default __exports__